import { cached } from '@glimmer/tracking';

import { uniq } from 'webapp/utils/common';

import CommonCollapsiblePillOptionsComponent from 'webapp/components/common/collapsible-pill-options';
import CustomMetricsEditActionsBaseComponent, {
	MAX_OPTIONS_SHOWN_ON_PAGE,
} from 'webapp/components/custom-metrics/edit/actions/base';
import type { Args as BaseArgs } from 'webapp/components/custom-metrics/edit/actions/base';

import type { Script } from 'webapp/models-custom';

interface Args extends BaseArgs {
	model: Script;
}

export default class CustomMetricsEditActionsScriptComponent extends CustomMetricsEditActionsBaseComponent<Args> {
	origin = 'data_calculations';

	get sourceTypes() {
		const sourceTypes = this.args.model.usedSources.map((source) => source.sourceType.key);
		return uniq(sourceTypes);
	}

	get showDuplicate() {
		return !this.args.model.isNew;
	}

	get showDelete() {
		return !this.args.model.isNew;
	}

	@cached
	get options() {
		const options = [];
		if (this.showGetAssistance) {
			options.push(this.getAssistanceAction);
		}
		if (this.showDuplicate) {
			options.push(this.duplicateAction);
		}
		if (this.showDelete) {
			options.push(this.deleteAction);
		}
		return options;
	}

	<template>
		<CommonCollapsiblePillOptionsComponent
			@itemsList={{this.options}}
			@maxVisibleItems={{MAX_OPTIONS_SHOWN_ON_PAGE}}
			@doAction={{this.doAction}}
		/>
	</template>
}
